import actionType from "./actionType";
import { State } from "./state";
import { Asset, GeneralProject } from "../../interface/Server";

export interface Action {
  type: actionType;
  payload: {
    nextStep?: number;
    selectedAsset?: Asset;
    selectedProject?: GeneralProject;
    user?: {};
    screen?: string;
    startTime?: Date;
    userName?: string;
  };
}

const dispatch = (state: State, action: Action): State => {
  const asset = action.payload.selectedProject
    ? {
        selectedProject: action.payload.selectedProject,
        selectedAsset: undefined,
      }
    : {
        selectedAsset: action.payload.selectedAsset,
        selectedProject: undefined,
      };

  console.info("Dispatch Recieved");
  console.info(state);
  console.info(action);
  console.info(asset);

  switch (action.type) {
    case actionType.START_FORM_STAGE: {
      return {
        ...state,
        formStep: 1,
        ...asset,
      };
    }
    case actionType.REFRESH_STAGE: {
      return {
        ...state,
        formStep: action.payload.nextStep,
        ...asset,
      };
    }
    case actionType.RESET_FORM_STAGE: {
      return {
        ...state,
        formStep: 0,
      };
    }
    case actionType.GO_TO_FORM_STAGE: {
      return {
        ...state,
        formStep: action.payload.nextStep,
      };
    }
    case actionType.LOGIN_SUCCESSFUL: {
      return {
        ...state,
        user: {
          ...state.user,
          ...action.payload.user,
        },
        startTime: action.payload.startTime,
      };
    }
    case actionType.LOGOUT_SUCCESSFUL: {
      return {
        ...state,
        startTime: undefined,
      };
    }
    case actionType.SET_START_TIME: {
      return {
        ...state,
        startTime: action.payload.startTime,
      };
    }
    case actionType.SET_SCREEN: {
      return {
        ...state,
        screen: action.payload.screen || "",
      };
    }
    case actionType.SET_USERNAME: {
      return {
        ...state,
        userName: action.payload.userName || "",
      };
    }
    default:
      return state;
  }
};

export default dispatch;
